import type { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import type { CollectionModelBase } from '../collection.base';
import type { CollectionModelField } from '../collection.field';

type FieldFactoryFn = (parent: CollectionModelBase, schema: FormModelField) => CollectionModelField;

const fieldTypes = new Map<IkeFieldType, FieldFactoryFn>();

/** Register a field type constructor. Called by each field module at init time. */
export function registerFieldType(type: IkeFieldType, factory: FieldFactoryFn) {
	fieldTypes.set(type, factory);
}

/** Create a field instance from a schema definition. */
export function createField(parent: CollectionModelBase, schema: FormModelField): CollectionModelField {
	const factory = fieldTypes.get(schema.type);
	if (!factory) {
		throw new Error(`Schema "${schema.id}": Unable to find field type:${schema.type}`);
	}
	return factory(parent, schema);
}
